// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface SubtractIconSignature {
  Element: SVGSVGElement;
}

export const SubtractIcon: TOC<SubtractIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<rect x="3" y="11" width="18" height="2"/>
</svg>
</template>;